import React from 'react';

export default function IcBox() {
  return (
    <svg width="18px" height="24px" viewBox="0 0 309.7 308" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g>
            <path d="M309.7,86.9c0-1.7-0.9-3.2-2.4-4l-150-82.2c-0.5-0.3-1.1-0.5-1.6-0.6c-1.1-0.2-2.2,0.1-3.1,0.6l-48.7,26.5
                c-0.3,0.1-0.7,0.2-0.9,0.4L59.1,51.7L2.4,82.9c-1.5,0.8-2.4,2.3-2.4,4v134.3c0,1.7,0.9,3.2,2.4,4l150,82.2c0.5,0.3,1.2,0.5,1.8,0.6
                h1.1c0.6-0.1,1.2-0.2,1.8-0.6l150.2-82.3c1.5-0.8,2.4-2.3,2.4-4L309.7,86.9z M105.2,37l139.2,77.9l-36,19.8L70.8,55.8L105.2,37z
                M213.3,142.9l36.2-19.9v56.2l-36.2,21.3V142.9z M154.8,9.7l140.7,77.1l-41.3,22.7L114.7,31.8L154.8,9.7z M61.3,61l137.9,78.7
                l-44.4,24.4l-15.6-8.6L14.2,86.9L61.3,61z M9.2,94.6l125.6,68.9l15.5,8.5v123.8l-141-77.4L9.2,94.6z M300.4,218.5l-141,77.4V172.1
                l44.8-24.5l0,60.9c0,1.6,0.9,3.2,2.3,4c1.4,0.8,3.2,0.8,4.6,0l45.4-26.8l0,0c1.4-0.8,2.2-2.4,2.2-4v-64.1l41.6-22.9L300.4,218.5z"
                />
        </g>
    </svg>
  );
}
